import { Component } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { MainNavbarComponent } from '../main-navbar/main-navbar.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [MainNavbarComponent,CommonModule,MainNavbarComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
constructor(private router:Router){}
roles:string |null=null;
ngOnInit(): void {
  this.roles=JSON.parse(localStorage.getItem('roles')!);
}
  openCompanySearch(){
    this.router.navigate(['/company-search'])
  }


  openThematicSearch(){
    this.router.navigate(['/thematic-search'])
  }

  openIdeaGeneration(){
    this.router.navigate(['/idea-generation'])
  }
  openProBot(){
    this.router.navigate(['/pro-bot'])
  }
  openMonitoring(){
    this.router.navigate(['/monitoring'])
  }
}
